export default __webpack_public_path__ + "i18n/translations/translation-de.48ebc23b.json";